/**
 * Powód `abort()` odczytów buildera poprzedniej karty (TraineeStoreGate). Oczekiwany, więc filtr
 * w main.tsx nie wysyła go do Sentry. Osobny plik, żeby main.tsx nie wciągał kodu kart klientek.
 */
export const TRAINEE_STORE_ABORT_REASON = "Redux przechodzi na klientkę innej karty";
